import type { Money } from "../types";

const formatterCache = new Map<string, Intl.NumberFormat>();

function getFormatter(locale: string, currencyCode: string) {
  const key = `${locale}:${currencyCode}`;
  let f = formatterCache.get(key);
  if (!f) {
    f = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
    });
    formatterCache.set(key, f);
  }
  return f;
}

export function formatMoney(money: Money, locale: string): string {
  const num = Number.parseFloat(money.amount);
  if (Number.isNaN(num)) return "";
  return getFormatter(locale, money.currencyCode).format(num);
}

/**
 * 표시용 할인가 계산. 센트 단위 반올림.
 * 실제 결제 금액은 할인 앱이 체크아웃에서 정하므로, 여기 값은 안내용이다.
 */
export function discountedMoney(money: Money, percent: number): Money {
  const num = Number.parseFloat(money.amount);
  if (Number.isNaN(num) || percent <= 0) return money;
  return { ...money, amount: (num * (1 - percent / 100)).toFixed(2) };
}

/**
 * Storefront API의 GID(gid://shopify/ProductVariant/1234)에서 숫자 ID만 추출.
 * AJAX cart(/cart/add.js)는 숫자 ID를 요구한다.
 */
export function gidToNumericId(gid: string): string {
  const match = gid.match(/\/(\d+)(?:\?.*)?$/);
  return match ? match[1] : gid;
}

/** title 이 prefix 로 시작하는지 (대소문자 무시). */
export function matchesCollectionTitlePrefix(
  title: string,
  prefix: string
): boolean {
  if (!prefix) return true;
  return title.toLowerCase().startsWith(prefix.toLowerCase());
}

/** 컬렉션 pill 등 UI 에서 title prefix(예: PC_) 를 제거한 표시명. */
export function formatCollectionDisplayTitle(
  title: string,
  prefix: string
): string {
  if (!prefix) return title;
  if (matchesCollectionTitlePrefix(title, prefix)) {
    return title.slice(prefix.length).trim();
  }
  return title;
}
